'use strict'

export const buildNetsuiteTransactionUrl = (appUrl, netsuiteInternalId) => {
  if (!/^\d+$/.test(String(netsuiteInternalId || ''))) {
    throw new Error('numeric NetSuite internal id required')
  }
  const baseUrl = normalizeAppUrl(appUrl)
  return `${baseUrl}/app/accounting/transactions/transaction.nl?id=${netsuiteInternalId}`
}

export const isHttpsUrl = (value) => {
  if (typeof value !== 'string' || !value) return false
  try {
    return new URL(value).protocol === 'https:'
  } catch (_) {
    return false
  }
}

export const isIsoDateTime = (value) =>
  typeof value === 'string' && !Number.isNaN(Date.parse(value))

export const normalizeNetsuiteTransactionIdentity = (identity, appUrl) => {
  if (!identity || typeof identity !== 'object') throw new Error('NetSuite transaction identity required')
  if (typeof identity.tranId !== 'string' || !identity.tranId.trim()) {
    throw new Error('NetSuite tranId required')
  }
  if (String(identity.netsuite_internalId) === identity.tranId) {
    throw new Error('NetSuite internal id must differ from tranId')
  }
  return {
    netsuite_internalId: String(identity.netsuite_internalId),
    tranId: identity.tranId,
    url: buildNetsuiteTransactionUrl(appUrl, identity.netsuite_internalId),
    status: identity.status || null,
  }
}

const normalizeAppUrl = (appUrl) => {
  if (typeof appUrl !== 'string' || !/^https:\/\/[a-z0-9-]+\.app\.netsuite\.com$/i.test(appUrl)) {
    throw new Error('valid NetSuite app URL required')
  }
  return appUrl.replace(/\/+$/u, '')
}
